import { gql } from "graphql-tag"

const socials = gql`
  type Mutation {
    socialsAiInstructionAdd(
      socialsAiInstructionAddInput: SocialsAiInstructionAddInput!
    ): SocialsAiInstructionAddResponse!

    socialsAiInstructionDelete(id: ID!): SocialsAiInstructionDeleteResponse!

    socialsAiInstructionUpdate(
      socialsAiInstructionUpdateInput: SocialsAiInstructionUpdateInput!
    ): SocialsAiInstructionUpdateResponse!

    socialsAuthorAdd(
      socialsAuthorAddInput: SocialsAuthorAddInput!
    ): SocialsAuthorAddResponse!

    socialsGeneratePosts(
      socialsGeneratePostsInput: SocialsGeneratePostsInput!
    ): SocialsGeneratePostsResponse!

    socialsPlatformAdd(
      socialsPlatformAddInput: SocialsPlatformAddInput!
    ): SocialsPlatform!

    socialsPlatformGatherPosts(
      socialsPlatformGatherPostsInput: SocialsPlatformGatherPostsInput!
    ): SocialsPlatformGatherPostsResponse!

    socialsPostsAdd(
      socialsPostsAddInput: SocialsPostsAddInput!
    ): SocialsPostsAddResponse!

    socialsHandleUpdate(
      socialsHandleUpdateInput: SocialsHandleUpdateInput!
    ): SocialsHandle!

    """
    Trigger a Bluesky follower sync run for the given accountId.
    Returns a GraphQL error with code 409 when a sync is already running.
    """
    socialsFollowerSyncRun(
      socialsFollowerSyncRunInput: SocialsJobRunInput!
    ): SocialsJobRunResponse!

    """
    Trigger a Bluesky discovery ingest run for the given accountId.
    Returns a GraphQL error with code 409 when an ingest is already running.
    """
    socialsDiscoveryRun(
      socialsDiscoveryRunInput: SocialsJobRunInput!
    ): SocialsJobRunResponse!
  }
`

export default socials
